import { useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Select } from '../../../../../components/inputs/Select';
import { Spinner } from '../../../../../components/widgets/Spinner';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../../utils/dados-login.util';
import { ActionButtons } from '../components/ActionButtons';
import { LayoutGestaoLeads } from '../components/LayoutGestaoLeads';
import { NoOrderedList } from '../components/NoOrderedList';
import { useEquipesContext } from '../context/EquipesContext';

export const AlterarEquipe = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { state }: any = useLocation();

  const { showToast, handleShowToast } = useEquipesContext();

  const [allUsers, setAllUsers] = useState([]);
  const [allUsersLoading, setAllUsersLoading] = useState(true);
  const [allTeams, setAllTeams] = useState([]);

  const [tipoCliente, setTipoCliente] = useState('Todos');
  const [teamName, setTeamName] = useState('');

  const [alertText, setAlertText] = useState(false);
  const [alertRadio, setAlertRadio] = useState(false);
  const [alertSelect, setAlertSelect] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState('');

  const [dropdownUsers, setDropdownUsers] = useState(false);

  const [loading, setLoading] = useState(false);

  const [usersList, setUsersList] = useState([]);
  const [usersDeleted, setUsersDeleted] = useState([]);
  const [usersAdd, setUsersAdd] = useState([]);

  const [buttonSaveDisabled, setButtonSaveDisabled] = useState(true);

  const mockedProducts = [
    { name: 'Vida Individual', value: 'Vida' },
    { name: 'Vida Coletivo', value: 'Vida Coletivo' },
    { name: 'Odonto Individual', value: 'Odonto' },
    { name: 'Odonto Empresa', value: 'Odonto Empresa' },
    { name: 'Saúde', value: 'Saúde' },
    { name: 'Saúde PRC', value: 'Saúde PRC' },
    { name: 'Viagem', value: 'Viagem' },
    { name: 'Previdência', value: 'Previdência' }
  ];

  const getAllUsers = async () => {
    setAllUsersLoading(true);
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/usuarios`,
        {
          timeout: 0
        }
      );

      const filterUsers = data
        .filter((user: any) => {
          return user.tipo !== 'gestor' && user.status === 'ativo';
        })
        .map((user) => ({
          value: { id: user.id, nome: user.nome, tipo: user.tipo },
          label: user.nome
        }));

      setAllUsers(filterUsers);
    } catch (error: any) {
      console.log(error);
    } finally {
      setAllUsersLoading(false);
    }
  };

  const getAllTeams = async () => {
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/equipes`,
        {
          timeout: 0
        }
      );

      setAllTeams(data);
    } catch (error: any) {
      console.log(error);
    }
  };

  const getUsers = async (idUsers: string) => {
    setLoading(true);
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/equipes/${idUsers}/users`,
        {
          timeout: 0
        }
      );
      const dadosLogin = await getDadosLogin();

      const producerCode = dadosLogin?.producerCode || '';

      const filteredData = data.filter((users: any) => {
        return users.codigo_produtor === producerCode;
      });

      const filteredStatus = filteredData.filter((user: any) => {
        return user.status === 'ativo';
      });

      setUsersList(filteredStatus);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleUserList = (user: { id: string; nome: string; tipo: string }) => {
    setUsersList(usersList.filter((item) => item !== user));

    const newUsersDeleted = [...usersDeleted, user];
    setUsersDeleted(newUsersDeleted);
  };

  const handleInputChange = (value: string) => {
    if (value?.length <= 40) {
      setTeamName(value);
    }
  };

  const handleRadioChange = (index: number) => {
    const inputChecked = mockedProducts[index]?.value;
    setSelectedProduct(inputChecked);
  };

  const handleSelectTipoCliente = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTipoCliente(e.target.value);
  };

  const handleSelectedUsers = (user: {
    id: string;
    nome: string;
    tipo: string;
  }) => {
    if (!usersList.some((item) => item.id === user.id)) {
      setUsersList([...usersList, user]);

      const newUsersAdd = [...usersList, user];
      const userAddMap = newUsersAdd.map((user) => user.id);

      setUsersAdd(userAddMap);
    }
    setDropdownUsers(!dropdownUsers);
    setAlertSelect(false);
  };

  const handleCreateTeam = () => {
    const teamNamesFilted = allTeams.filter(
      (team) => team.nome.toLowerCase() === teamName.toLowerCase()
    );
    const teamNameFilted = teamNamesFilted.filter(
      (team) => team.nome.toLowerCase() === state?.equipe?.nome.toLowerCase()
    );

    const body = {
      nome: teamName,
      tipo_produto: selectedProduct,
      tipo_cliente: tipoCliente
    };

    let alertType = null;

    switch (true) {
      case teamName === '':
        alertType = 'alertText';
        break;

      case teamNameFilted.length === 0 && teamNamesFilted.length > 0:
        alertType = 'alertText';
        break;

      case selectedProduct === '':
        alertType = 'alertRadio';
        break;

      case usersList.length < 1:
        alertType = 'alertSelect';
        break;

      default:
        break;
    }

    setAlertText(alertType === 'alertText');
    setAlertRadio(alertType === 'alertRadio');
    setAlertSelect(alertType === 'alertSelect');

    if (!alertType) {
      handleSubmit(body);
    }
  };

  const handleRedirect = async (url: string) => {
    await handleShowToast();
    navigate(url);
  };

  const handleSubmit = async (body: {
    nome: any;
    tipo_produto: any;
    tipo_cliente: string;
  }) => {
    const { equipe } = state || {};
    const {
      id,
      nome: equipeNome,
      tipo_produto: equipeTipoProduto
    } = equipe || {};

    const usersToAdd = [...usersAdd];
    const usersToDelete = [...usersDeleted];

    try {
      let shouldRedirect = false;

      if (usersToAdd.length > 0) {
        await apiSensedia.put(
          `/oportunidades-sulamerica/painel-leads/equipes/${id}/users`,
          { users: usersToAdd }
        );
        shouldRedirect = true;
      }

      if (usersToDelete.length > 0) {
        const deletePromises = usersToDelete.map((user) =>
          apiSensedia.put(
            `/oportunidades-sulamerica/painel-leads/equipes/${id}/users/${user.id}`
          )
        );
        await Promise.all(deletePromises);
        shouldRedirect = true;
      }

      if (equipeNome !== body.nome || equipeTipoProduto !== body.tipo_produto) {
        await apiSensedia.put(
          `/oportunidades-sulamerica/painel-leads/equipes/${id}`,
          body,
          {
            timeout: 0
          }
        );
        shouldRedirect = true;
      }

      if (shouldRedirect) {
        handleRedirect('/corretor/leads/equipes');
      }
    } catch (err: any) {
      if (err.response?.data?.data?.message) {
        return toast({
          title: 'Ops!',
          description: err.response?.data?.data?.message,
          status: 'error',
          duration: 9000,
          isClosable: true
        });
      }

      toast({
        title: 'Erro',
        description:
          'Não foi possível cadastrar a equipe. Lamentamos o transtorno.',
        status: 'error',
        duration: 9000,
        isClosable: true
      });
      console.error({ err });
    }
  };

  const handleSaveButtonDisabled = () => {
    switch (true) {
      case state?.equipe?.tipo_produto !== selectedProduct:
      case state?.equipe?.nome !== teamName:
      case state?.equipe?.tipo_cliente !== tipoCliente:
      case usersAdd.length > 0:
      case usersDeleted.length > 0:
        setButtonSaveDisabled(false);
        break;
      default:
        setButtonSaveDisabled(true);
        break;
    }
  };

  useEffect(() => {
    const teamNamesFilted = allTeams.filter(
      (team) => team.nome.toLowerCase() === teamName.toLowerCase()
    );

    const teamNameFilted = teamNamesFilted.filter(
      (team) => team.nome.toLowerCase() === state?.equipe?.nome.toLowerCase()
    );

    if (teamNamesFilted.length > 0 && teamNameFilted.length <= 0) {
      setAlertText(true);
    } else {
      setAlertText(false);
    }
  }, [teamName]);

  useEffect(() => {
    getAllUsers();
    getAllTeams();
  }, []);

  useEffect(() => {
    handleInputChange(state?.equipe?.nome);
    setSelectedProduct(state?.equipe?.tipo_produto);
    setTipoCliente(state?.equipe?.tipo_cliente);
    getUsers(state?.equipe?.id);
  }, []);

  useEffect(() => {
    handleSaveButtonDisabled();
  }, [state, selectedProduct, teamName, usersAdd, usersDeleted]);

  return (
    <LayoutGestaoLeads>
      <div className="tw-bg-white tw-rounded-3xl tw-mt-[1.87rem]">
        <h1 className="tw-p-[1.88rem] tw-font-bold tw-text-[1.25rem] tw-leading-[2rem] tw-text-[#323232]">
          Adicionar equipe
        </h1>
        <div className="tw-px-[1.88rem]">
          <p className="tw-font-bold">Produto</p>
          <div className="tw-mt-[0.62rem] tw-grid tw-grid-cols-2 tw-gap-x-[1.25rem] tw-gap-y-[0.62rem]">
            {' '}
            {mockedProducts.map((product, index) => {
              return (
                <div
                  key={index}
                  className="tw-flex tw-items-center tw-gap-[0.25rem]"
                >
                  {' '}
                  <input
                    type="radio"
                    name="product"
                    value={product.value}
                    onChange={() => {
                      handleRadioChange(index), setAlertRadio(false);
                    }}
                  />{' '}
                  <span
                    className={`${
                      alertRadio ? 'tw-text-[#AA2C23]' : 'tw-text-[#001E64]'
                    }`}
                  >
                    {product.name}{' '}
                  </span>{' '}
                </div>
              );
            })}{' '}
          </div>
          {alertRadio && (
            <p className="tw-text-[#AA2C23] tw-font-bold">
              Por favor, selecione um dos produtos
            </p>
          )}
        </div>
        <div className="tw-px-[1.88rem] tw-mt-[1.87rem]">
          <label className="tw-block tw-font-bold">Tipo de cliente</label>
          <select
            className="tw-mt-[0.62rem] tw-border-r-8 tw-border-transparent tw-px-2 tw-outline tw-outline-1 tw-outline-black focus:tw-outline-2 focus:tw-outline-blue-500 tw-rounded-md tw-block tw-w-30 tw-p-2.5"
            onChange={handleSelectTipoCliente}
          >
            <option value="Todos">Todos</option>
            <option value="CPF">Pessoa física</option>
            <option value="CNPJ">Pessoa jurídica</option>
          </select>
        </div>
        <div className="tw-px-[1.88rem] tw-mt-[1.87rem]">
          <label className="tw-font-bold tw-text-[1rem]">Nome da equipe</label>
          <br />
          <input
            className={`${
              alertText ? 'tw-border-[#AA2C23]' : 'tw-border-[#001E64]'
            } tw-mt-[0.63rem] tw-w-full tw-max-w-[40.1rem] tw-border-[0.0625rem] tw-rounded-md tw-py-[0.88rem] tw-px-[1.25rem] tw-focus:outline-none tw-focus:shadow-outline`}
            placeholder="Nome da equipe"
            type="text"
            value={teamName}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
          />
          <span className="tw-flex tw-justify-between tw-w-full tw-max-w-[40.1rem]">
            <p
              className={`${
                alertText ? 'tw-visible' : 'tw-invisible'
              } tw-text-[#AA2C23] tw-font-bold`}
            >
              Este nome de equipe já está em uso. Tente outro
            </p>
            <p className="tw-text-[0.875rem] tw-text-[#5A5A5A]">{`${teamName.length}/40`}</p>
          </span>
        </div>
        <div
          className={`${
            usersList.length === 0 && 'tw-mb-[1.88rem]'
          } tw-mt-[3.63rem] tw-flex tw-flex-col tw-px-[1.88rem]`}
        >
          <label className="tw-font-bold tw-text-[1rem]">
            Adicionar usuário nessa equipe
          </label>

          <span className="tw-text-[0.875rem] tw-text-[#323232]">
            Você deve <strong>inserir no mínimo 1 usuário</strong> para criação
            de uma equipe
          </span>
          <div className="tw-relative tw-mt-[0.63rem]">
            <Select
              options={allUsers}
              isSearchable
              className="tw-w-full tw-max-w-[40.1rem]"
              placeholder="Adicionar usuário nessa equipe"
              onChange={(e) => {
                handleSelectedUsers(e.value);
              }}
              isLoading={allUsersLoading}
              noOptionsMessage={() => 'Nenhum usuário disponível'}
            />
            <span className="tw-flex tw-justify-between tw-w-full tw-max-w-[40.1rem]">
              <p
                className={`${
                  alertSelect ? 'tw-visible' : 'tw-invisible'
                } tw-text-[#AA2C23] tw-font-bold`}
              >
                Por favor, adicione usuário nessa equipe
              </p>
            </span>
          </div>
        </div>
        {loading ? (
          <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-[10rem]">
            <Spinner />
          </div>
        ) : (
          <NoOrderedList
            title={'Lista de usuários adicionados'}
            dataList={usersList}
            handleDataList={handleUserList}
          />
        )}

        <ActionButtons
          disabledButton={buttonSaveDisabled}
          prevText={'Voltar'}
          prevAction={() => {
            navigate('/corretor/leads/equipes');
          }}
          nextText={'Salvar'}
          nextAction={handleCreateTeam}
        />
      </div>
    </LayoutGestaoLeads>
  );
};
